export const IMAGE_UPLOAD_MAX_MIB = 60;
export const IMAGE_UPLOAD_MAX_BYTES = IMAGE_UPLOAD_MAX_MIB * 1024 * 1024;

// Fal rejects image references at 25,000,000 decimal bytes. Outputs must be
// strictly smaller than this value; source acquisition remains bounded by the
// user-facing image intake allowance.
export const FAL_IMAGE_REFERENCE_REJECTION_BYTES = 25_000_000;
export const FAL_IMAGE_REFERENCE_MAX_SOURCE_BYTES = IMAGE_UPLOAD_MAX_BYTES;
